import React, { useState, useEffect } from 'react';
import { LuMenu, LuX } from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';
import { useLocation, useNavigate, Link } from 'react-router-dom';

export default function Navbar({ onBook }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Beranda', href: '#beranda' },
    { name: 'Tentang Kami', href: '#tentang' },
    { name: 'Layanan', href: '#layanan' },
    { name: 'Testimoni', href: '#testimoni' },
    { name: 'FAQ', href: '#faq' }
  ];

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const targetId = href.replace('#', '');

    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          const y = element.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 150);
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-md py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" onClick={() => window.scrollTo(0,0)} className="flex items-center">
            <img 
              src="/images/logo-garuda.png" 
              alt="Garuda Ekspress Logistik" 
              className="h-[32px] md:h-[38px] w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <a 
                key={link.name} 
                href={link.href} 
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-navy/80 hover:text-orange font-medium transition-colors text-sm xl:text-base cursor-pointer"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <button 
              onClick={() => onBook('Garuda Reguler (G-Reg)')}
              className="font-heading bg-orange hover:bg-[#d94f1e] text-white px-7 py-2.5 rounded-full font-medium transition-all transform hover:-translate-y-0.5 shadow-lg shadow-orange/30"
            >
              Kirim Sekarang
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className="lg:hidden text-navy p-2 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <SafeIcon icon={isMobileMenuOpen ? LuX : LuMenu} className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100 py-4 px-4 flex flex-col gap-2">
          {navLinks.map((link) => (
             <a 
               key={link.name} 
               href={link.href} 
               onClick={(e) => handleNavClick(e, link.href)} 
               className="text-navy font-medium p-3 hover:bg-gray-50 rounded-lg transition-colors"
             >
               {link.name}
             </a>
          ))}
          <button 
            onClick={() => {
              setIsMobileMenuOpen(false);
              onBook('Garuda Reguler (G-Reg)');
            }}
            className="font-heading bg-orange text-white text-center px-6 py-3 rounded-lg font-medium mt-2 shadow-md shadow-orange/20"
          >
            Kirim Sekarang
          </button>
        </div>
      )}
    </header>
  );
}